import ConfiguratorSelect from './configurator-select';

class ConfiguratorLeasing {
    constructor() {
        this.leasingSelects = new ConfiguratorSelect('.js-leasing-options');
        this.prices = jQuery('.js-configurator-price');
    }

    _events() {
        this.leasingSelects.onChange((select, target) => {
            const ratio = parseFloat(target.value);
            const other = select.not(target);
            const name = jQuery(target).find("option:selected").data("name");
            PRODUCTCONFIG.set('leasing-ratio', ratio);
            PRODUCTCONFIG.set('leasing-plan', name);
            PRODUCTCONFIG.save();
            const otherSelected = other.find(`option[value="${ratio}"]`);
            otherSelected.attr("selected",true).siblings().attr("selected",false);
            const placeholder = otherSelected.text();
            other.select2({
                    placeholder
                }
            );
        });
    }

    init() {
        if (this.leasingSelects && this.prices.length) {
            try {
                this._events();
            } catch (e) {

            }
        }
    }
}

export default ConfiguratorLeasing;
